import React from 'react';

import { useIntl } from 'react-intl-next';

import Button from '@atlaskit/button/new';
import { aiProactiveMessages } from '@atlaskit/editor-common/ai-messages';
import Heading from '@atlaskit/heading';
import Image from '@atlaskit/image';
import { Stack, Text } from '@atlaskit/primitives/compiled';

import EnableSuggestionsImageDark from '../assets/enable-suggestions/dark.svg';
import EnableSuggestionsImageLight from '../assets/enable-suggestions/light.svg';

export const EnableSuggestionsState = ({ handleEnable }: { handleEnable: () => void }) => {
	const { formatMessage } = useIntl();

	return (
		<Stack space="space.200" alignInline="center" grow="fill">
			<Image src={EnableSuggestionsImageLight} srcDark={EnableSuggestionsImageDark} />
			<Stack space="space.200" alignInline="center">
				<Heading color="color.text" size="small">
					{formatMessage(aiProactiveMessages.enableSuggestionsStateTitle)}
				</Heading>
				<Text align="center" color="color.text" size="medium">
					{formatMessage(aiProactiveMessages.enableSuggestionsStateDescription)}
				</Text>
				<Button appearance="primary" onClick={handleEnable}>
					{formatMessage(aiProactiveMessages.enableSuggestionsButtonLabel)}
				</Button>
			</Stack>
		</Stack>
	);
};
